import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { CompetitiveIntelligencePage } from "@/components/site/CompetitiveIntelligencePage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/media-analysis/competitive-intelligence")({
  head: () => ({
    meta: [
      { title: "Competitive Intelligence Analysis | Perceptica" },
      { name: "description", content: "Perceptica's competitive intelligence analysis benchmarks your brand against rivals - share of voice, narratives, sentiment and gaps. See a sample report." },
      { property: "og:title", content: "Competitive Intelligence Analysis | Perceptica" },
      { property: "og:description", content: "Perceptica's competitive intelligence analysis benchmarks your brand against rivals - share of voice, narratives, sentiment and gaps. See a sample report." },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Competitive Intelligence Analysis | Perceptica" },
      { name: "twitter:description", content: "Perceptica's competitive intelligence analysis benchmarks your brand against rivals - share of voice, narratives, sentiment and gaps. See a sample report." },
      { property: "og:url", content: "https://perceptica.com/media-analysis/competitive-intelligence" },
      ...ogImageMeta("en", "/media-analysis/competitive-intelligence"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-analysis/competitive-intelligence", service: { name: "Competitive intelligence analysis", description: "Perceptica competitive intelligence analysis for Southeast Europe.", serviceType: "Competitive intelligence analysis" } }),
  }),
  component: CompetitiveIntelligencePage,
});
